import { VigilanceTokenClient } from "@/Common/Api/VigilanceSante/VigilanceTokenClient";

export class VigilanceQueryViewerPopupHelper {
    private static readonly windowName = "vigilanceV2";
    private static readonly windowArguments = "height=600,width=800,popup=yes";

    /**
     * Open a popup to show medication information from Vigilance Santé.
     * @param url The Vigilance Santé service URL.
     * @param monographCode The code of the medication to display.
     */
    public static async openVigilancePopupForMonograph(monographieCode: string): Promise<void> {
        const languageCode = sessionStore.getUserLanguageCodeFRorEN();
        const vigilanceUrl = cacheStore.ClinicSettingsServices.VigilanceServiceV2;
        const token = await VigilanceTokenClient.getVigilanceTokenAsync();
        window.open(`https://${vigilanceUrl}/module/mono/${languageCode}/${monographieCode}.htm?token=${token}`, this.windowName, this.windowArguments);
    }

    /**
     * Open a popup to show the Vigilance Santé medication search.
     * @param url The Vigilance Santé service URL.
     */
    public static async openVigilancePopupForSearch(): Promise<void> {
        const languageCode = sessionStore.getUserLanguageCodeFRorEN();
        const vigilanceUrl = cacheStore.ClinicSettingsServices.VigilanceServiceV2;
        const token = await VigilanceTokenClient.getVigilanceTokenAsync();
        window.open(`https://${vigilanceUrl}/module/accueil/accueil-ndx.html?token=${token}&language=${languageCode}`, this.windowName, this.windowArguments);
    }

    public static openVigilanceViewerPopup(vigilanceUrl: string, patientData: string, token: string): void {
        const vigilanceWindow = window.open(`${rootPath}/vigilance`, this.windowName, this.windowArguments);

        function vigilanceWindowOnLoadHandler(): void {
            vigilanceWindow.onload = null;
            vigilanceWindow["redirect"](`https://${vigilanceUrl}/service/rxvengine/queryviewer/`, patientData, token);
        }

        try {
            vigilanceWindow.onload = vigilanceWindowOnLoadHandler;
        }
        catch {
            // hack to avoid cross-frame errors
            window.setTimeout(
                () => {
                    if (vigilanceWindow.document.readyState === "complete")
                        vigilanceWindow["redirect"](`https://${vigilanceUrl}/service/rxvengine/queryviewer/`, patientData, token);
                    else
                        vigilanceWindow.onload = vigilanceWindowOnLoadHandler;
                },
                1000
            );
        }
    }
}
